export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,

        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'export'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Keresés',
                event_name: "customClick",
                class: "btn btn btn-danger my-custom-class",
                event_payload: 'search'
            }
        ],
        
        headerFields: [
            {
                name: "id",
                label: "Azonosító",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: false,
            },
            {
                name: "siteName",
                label: "Telephely",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "treatmentTypeTitle",
                label: "Kezelés típusa",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "treatmentStatusName",
                label: "Kezelés állapota",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "appointmentStatusName",
                label: "Előjegyzés állapota",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "treatmentDate",
                label: "Kezelés dátuma",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: false,
            },
            {
                name: "rowCount",
                label: "Betegforgalom",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            }
        ]
    }
}
